import api from './api';
import { PackageUnit, CreatePackageUnitData, UpdatePackageUnitData } from '../types/packageUnit';

export const optionUnitService = {
  // Get all units for an option
  getByPackage: async (
    workspaceId: string,
    optionId: string
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/units`
    );
    return response.data;
  },

  // Add a unit to an option
  create: async (
    workspaceId: string,
    optionId: string,
    data: CreatePackageUnitData
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/units`,
      data
    );
    return response.data;
  },

  // Add multiple units to an option
  createMultiple: async (
    workspaceId: string,
    optionId: string,
    units: CreatePackageUnitData[]
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/units/bulk`,
      { units }
    );
    return response.data;
  },

  // Update a unit in an option
  update: async (
    workspaceId: string,
    optionId: string,
    unitId: string,
    data: UpdatePackageUnitData
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/units/${unitId}`,
      data
    );
    return response.data;
  },

  // Remove a unit from an option
  delete: async (
    workspaceId: string,
    optionId: string,
    unitId: string
  ) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/units/${unitId}`
    );
    return response.data;
  }
};
